import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useInView } from 'react-intersection-observer';
import classnames from 'classnames';

import { CDN_URL } from '../../constants';
import ContentsNav from '../ContentsNav';

const Intro = ({
  description,
  contents_title: contentsTitle,
  image,
  items,
  metadata,
  setSlide,
  ...rest
}) => {
  const [introRef, isIntroInView] = useInView({ threshold: 0.8, triggerOnce: true });
  const [isIntroInPartialView, setIsIntroInPartialView] = useState(false);
  const [isIntroInFullView, setIsIntroInFullView] = useState(false);
  const hasMetadata = !!metadata?.length;
  const hasItems = !!items?.length;

  useEffect(() => {
    if (isIntroInView) {
      setTimeout(() => {
        setIsIntroInPartialView(true);
        setTimeout(() => {
          setIsIntroInFullView(true);
        }, 2000);
      }, 100);
    }
  }, [isIntroInView]);

  return (
    <div
      className={classnames(
        'intro',
        { 'intro--fade-in': isIntroInPartialView },
        { 'intro--faded-in': isIntroInFullView },
      )}
      ref={introRef}
      {...rest}
    >
      <div className='intro__content'>
        {image && (
          <div className='intro__image' style={{ backgroundImage: `url(${CDN_URL}${image})` }} />
        )}
        <div className='container'>
          <div className='row'>
            <div className='col'>
              <div className='intro__content-container'>
                {description && (
                  <div
                    className='intro__description'
                    dangerouslySetInnerHTML={{ __html: description }}
                  />
                )}
                {hasMetadata && (
                  <div className='intro__metadata'>
                    {metadata.map((item, index) => {
                      return (
                        <div className='intro__metadata-item' key={`intro__metadata-item-${index}`}>
                          <div className='intro__metadata-title'>{item?.title}</div>
                          <div className='intro__metadata-description'>{item?.description}</div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {hasItems && (
        <div className='intro__nav'>
          <ContentsNav items={items} title={contentsTitle} setSlide={setSlide} />
        </div>
      )}
    </div>
  );
};

Intro.propTypes = {
  contents_title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.string,
  items: PropTypes.array,
  metadata: PropTypes.array,
  setSlide: PropTypes.func,
};

export default Intro;
